<template>
  <div>
    <bread-crumb></bread-crumb>
    <div class="cont-feed-audit">
      <div class="left-content">
        <iframe
          title="Inline Frame Example"
          width="428"
          height="926"
          :src='prewUrl'
        />
      </div>
      <div class="right-list">
        <base-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></base-table>
        <pagination
          @sizePageChange="paginationChangeProduct"
          :paginationDatas="paginationDataProduct"
        ></pagination>
        <div class="right-list-btns">
          <el-button type='primary' @click="agree">下线内容</el-button>
          <el-button @click="notAgree">不做处理</el-button>
        </div>
      </div>
    </div>

    <modal
      :isShow.sync="reasonFrom.seeReasonDialog"
      title="下线理由"
      width="414px"
      :isShowBtn="reasonFrom.isShowBtn"
      :btnText="reasonFrom.ordinaryBtnText"
      @clickHandler="viewReasonClick"
    >
      <el-form label-width="100px">
        <div class="ibody">
          <el-input v-model="reasonFrom.reason"></el-input>
        </div>
      </el-form>
    </modal>
  </div>
</template>

<script>
import baseTable from "../../../../components/baseTable"
import breadCrumb from "../../../../components/breadCrumb"
import pagination from '../../../../components/pagination'
import {
  pageOperations,
  processOperation
} from '@/api/man'
import { queryDictionaries } from '@/api/contentDistribution'
import modal from '@/components/modal'
import { mapState } from 'vuex';


export default {
  name: "contentfeedbackAudit",
  data() {
    return {
      feedbackTypes: [], // 所有反馈类型
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      reasonFrom: {
        seeReasonDialog: false,
        ordinaryBtnText: ["取消", "确认"],
        isShowBtn: [true, true], //弹窗是否能显示按钮
        reason: ''
      },
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: '姓名',
            prop: 'operationUser'
          },
          {
            label: '反馈时间',
            prop: 'createTime',
            tableStatus: 'createTime'
          },
          {
            label: '反馈内容',
            prop: 'feedbackDesc',
          },
          {
            label: '状态',
            prop: 'operationProcessType',
            tableStatus: 'operationProcessType'
          }
        ],
        tableType: 0
      },
      prewUrl:''
    }
  },
  components: {
    breadCrumb,
    baseTable,
    pagination,
    modal
  },
  created() {
    this.prewUrl = `${process.env.VUE_APP_BASEURL == '//beta-api.m.jd.com' ? ' https://cont-yf.healthjd.com' : ' https://cont.healthjd.com'}/content/${this.$route.query.id}`;
    console.log('------000----',this.prewUrl)
  },
  mounted() {

    queryDictionaries({
      tenantId: this.$commonJs.getTenantId(),
      typeList: [47],
    }).then(res => {
      console.log("🚀 ~ file: contentFeedbackAudit.vue:100 ~ mounted ~ res:", res)
      this.feedbackTypes = res;
      this.getArticleList();
    })
  },

  computed: {
    ...mapState(["imgHost", "userInfo"]),
  },
  methods: {
    paginationChangeProduct(val) {
      this.paginationDataProduct = val
      this.getArticleList()
    },
    // 点击同意按钮
    agree() {
      this.reasonFrom.seeReasonDialog = true;
    },
    notAgree() {
      // 不同意
      processOperation({
        tenantId: this.$commonJs.getTenantId(),
        operationTargetType: 1,
        operationTargetId: this.$route.query.id,
        processType: 1
      }).then(res => {
        console.log("🚀 ~ file: contentFeedbackAudit.vue:139 ~ notAgree ~ res:", res);
        this.$message({
          type: 'success',
          message: '处理成功'
        });
        this.$router.go(-1);
      })
    },
    //获取文章列表
    getArticleList() {
      let params = {
        tenantId: this.$commonJs.getTenantId(),
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
        operationTargetType: 1,
        operationType: 8,
        operationTargetId: this.$route.query.id
      }

      console.log('getArticleList -- params', params)
      pageOperations(params).then(res => {
        console.log("🚀 ~ file: contentFeedback.vue:228 ~ pageOperations ~ res:", res)
        this.tableData.tableList.splice(0, this.tableData.tableList.length)
        res?.data?.forEach(item => {
          this.feedbackTypes.forEach(it => {
            if (it.code == item.negativeFeedbackCode) {
              item.feedbackDesc = it.desc
            }
          })
          this.tableData.tableList.push(item)
        })
        this.paginationDataProduct.total = res.totalCount
        this.paginationDataProduct.currentPage = res.pageNo
        this.paginationDataProduct.pageSize = res.pageSize
      })
    },
    //查看理由
    viewReasonClick(arg) {

      if (arg == 'one') {
        this.reasonFrom.seeReasonDialog = false;
      } else {
        if (this.reasonFrom.reason.length > 0) {
          processOperation({
            tenantId: this.$commonJs.getTenantId(),
            operationTargetType: 1,
            operationTargetId: this.$route.query.id,
            processType: 2,
            processRemark: this.reasonFrom.reason
          }).then(res => {
            console.log("🚀 ~ file: contentFeedbackAudit.vue:180 ~ agree ~ res:", res)
            this.$message({
              type: 'success',
              message: '处理成功'
            });
            this.reasonFrom.seeReasonDialog = false
            this.reasonFrom.reason = ''
            this.$router.go(-1);
          })
        }else {
          this.$message({
            type: 'info',
            message: '请输入下线理由'
          });
        }
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.cont-feed-audit {
  display: flex;
  .left-content{
    width: 428px;
    padding-top: 18px;
    overflow: hidden;
    margin-right: 20px;
    iframe{
      border: none;
      padding: 0;
      margin: 0;
    }
  }
  .right-list{
    flex: 1;
  }
  .right-list-btns {
    border-top: 1px solid #ccc;
    margin-top: 20px;
    padding-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.ibody{
  padding:20px;
}
</style>
